import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import "react-image-gallery/styles/image-gallery.css";
import LoadCSSforfirstTime from "../../../../CloudStorage/LoadCSSforfirstTime";
import { useDispatch, useSelector } from "react-redux";
import {
  addtowishinOTSbyid,
  getOTSById,
} from "../../../../redux/ots/action";
import { formatNumberWithCommas } from "../../../Common/AllDateTimeReleventFormate";
import CustomReactQuillDescription from "../../../Common/CustomeLabel/ReactQuill/CustomReactQuillDescription";
import CustomeDurationLabel from "../../../Common/CustomeLabel/CustomeDurationLabel";
import AllTabPackageScroll from "./AllPackagedServices/AllTabPackageScroll";
import CustomeCategoryandSubcategory from "../../../Common/CustomeLabel/CustomeCategoryandSubcategory";
import Access from "../../../CustomComponents/Access/Access";
import CloudStorage from "../../../../CloudStorage/CloudStorage";
import { useRouteBaseStateContext } from "../../../../Context/RouteBaseStateContext";
import { IS_LOGGED_IN_USER } from "../../../../assests/extention/commonfunction";
import ReactImageGalleryCompoment from "../SearchContestParticipate/ContestDetails/ReactImageGalleryCompoment";

export default function PackagedDetails() {
  const { setOTSroute } = useRouteBaseStateContext();
  const laung = localStorage.getItem("laung");
  const path = "Assets/scss/FindWork.module.scss";
  const [lan, setLan] = useState(laung ?? "en");
  const { id } = useParams();
  const [modal, setModal] = useState(false);

  const navigate = useNavigate();
  useEffect(() => {
    LoadCSSforfirstTime(path);
  }, [path]);

  const dispatch = useDispatch();
  const otsdetails = useSelector(({ ots: { getotsbyid } }) => getotsbyid);

  useEffect(() => {
    dispatch(getOTSById(id));
  }, [id]);

  const checkaccessss = () => {
    setModal(true);
  };

  const state = { approvefrom: "buyer", type: "packagedservices" };

  const addtowishlist11 = (id) => {
    dispatch(addtowishinOTSbyid(id));
  };

  const handleNavigateToOTS = () => {
    navigate(`/${lan}/dashboard/myotsproducts?packageid=${id}`);
    setOTSroute("Packageservice");
  };

  // ✅ Prepare images for gallery
  const images =
    Array.isArray(otsdetails?.files) &&
    otsdetails?.files.map((file) => ({
      original: file.file,
      thumbnail: file.file,
    }));

  return (
    <div className="col-lg-10 mx-auto project-details packageddetails">
      {modal && (
        <Access
          modal={modal}
          setModal={setModal}
          pathurl={`/${lan}/otscontract/${id}`}
          state={state}
          checkpermission={"purchase_bxp"}
          masterID={otsdetails && otsdetails?.id}
          checkrole={false}
        />
      )}

      <p className="breadcrumbs">
        <a
          onClick={() => {
            navigate(`/${laung}/searchpackaged`);
          }}
        >
          OTS &gt;
        </a>
        {otsdetails?.title}
      </p>

      <div className="col-lg-10 mx-auto">
        <div className="row">
          <div className="col-md-6">
            <ReactImageGalleryCompoment images={images} />
          </div>
          <div className="col-md-6 package-right">
            <h3>{otsdetails?.title}</h3>

            <div className="price-duration">
              <div>
                <h6>Price</h6>
                <h2>$ {formatNumberWithCommas(otsdetails?.price)}</h2>
              </div>
              <div>
                <h6>Duration</h6>
                <h2>
                  <CustomeDurationLabel
                    duration={otsdetails?.duration}
                    duration_type={otsdetails?.duration_type}
                  />
                </h2>
              </div>
            </div>

            {/* {otsdetails?.industry_title && (
              <div className="lang-sec price-duration align-items-start flex-column">
                <h6>Industry</h6>
                <p>{otsdetails?.industry_title}</p>
              </div>
            )} */}

            <CustomeCategoryandSubcategory posts={otsdetails} showcate={false} />

            <div className="price-duration">
              <div>
                <h6>Description</h6>
                <CustomReactQuillDescription value={otsdetails?.description} />
              </div>
            </div>

            <div
              className="d-flex align-items-center"
              style={{ columnGap: "15px" }}
            >
              {otsdetails?.is_mine == 1 ? (
                <button
                  className="btn purchase-btn w-100"
                  onClick={() => handleNavigateToOTS()}
                >
                  View details
                </button>
              ) : (
                <button
                  className="btn purchase-btn w-100 mt-4"
                  onClick={() => checkaccessss()}
                >
                  Send Purchase Request
                </button>
              )}

              <button
                className="btn heart-btn mt-4"
                style={{ background: "transparent", padding: "0" }}
                onClick={() => {
                  if (IS_LOGGED_IN_USER) {
                    addtowishlist11(otsdetails?.id);
                  } else {
                    setModal(true);
                  }
                }}
              >
                {otsdetails?.wishlist == 1 ? (
                  <img
                    src={`${CloudStorage.cloudurl}/Assets/Images/project/heart-active.svg`}
                    alt=""
                  />
                ) : (
                  <img
                    src={`${CloudStorage.cloudurl}/Assets/Images/project/heart.svg`}
                    alt=""
                  />
                )}
              </button>
            </div>
          </div>
        </div>

        <AllTabPackageScroll otsdetails={otsdetails} />
      </div>
    </div>
  );
}
